import script from "./ResearchItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./ResearchItem.vue?vue&type=script&lang=ts&setup=true"

import "./ResearchItem.vue?vue&type=style&index=0&id=2c3455f1&lang=scss"

const __exports__ = script;

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QCard,QDialog});
